/** Enum for priority of different requests */ export var RequestPriority = /*#__PURE__*/ function(RequestPriority) {
    /* High priority*/ RequestPriority[RequestPriority["Priority1"] = 1] = "Priority1";
    /** Medium priority */ RequestPriority[RequestPriority["Priority5"] = 5] = "Priority5";
    /** Low priority */ RequestPriority[RequestPriority["Priority10"] = 10] = "Priority10";
    return RequestPriority;
}({});
